import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const TenderFormSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6">
      <div className="flex-1 min-w-0">
        {/* Header bar skeleton */}
        <div className="sticky top-0 z-10 mb-3 rounded-lg border bg-card p-3 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="h-7 w-56" />
              <Skeleton className="h-6 w-24 rounded-full" />
            </div>
            <Skeleton className="h-10 w-40 rounded-md" />
          </div>
        </div>

        {/* Tabs skeleton — matches bg-muted rounded pill container */}
        <div className="inline-flex h-10 items-center rounded-lg bg-muted p-1 gap-1">
          {[64, 56, 80, 72, 40, 56].map((w, i) => (
            <Skeleton key={i} className="h-7 rounded-sm bg-muted-foreground/10" style={{ width: w }} />
          ))}
        </div>

        {/* Tab content skeleton — matches rounded-lg border card */}
        <div className="mt-3 rounded-lg border bg-card p-6 shadow-sm">
          <div className="grid gap-4">
            <Skeleton className="h-5 w-40" />
            {/* Name field */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-9 w-full" />
            </div>
            {/* Description field */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-24 w-full" />
            </div>
            {/* Date fields row */}
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-9 w-full" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-9 w-full" />
              </div>
            </div>
            {/* More fields */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-9 w-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar skeleton */}
      <div className="order-first w-full min-w-0 shrink-0 space-y-4 xl:order-none xl:w-[280px]">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <div className="pt-4 space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    </div>
  )
}

export default TenderFormSkeleton
